// App.js
import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import './components/styles/microAnimations.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Loader from './components/Loader';
import MicroAnimations from './components/MicroAnimations';
import CursorEffect from './components/CursorEffect';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Main from './components/Main';
import Services from './components/Services';
import About from './components/About';
import Project from './components/Project';
import Contact from './components/Contact';

function App() {

  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  // Enregistrer ScrollTrigger SEULEMENT après le chargement
  useEffect(() => {
    if (!isLoading && typeof window !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      // Forcer un refresh de ScrollTrigger après le chargement
      ScrollTrigger.refresh();
    }
  }, [isLoading]);

  return (
    <>
      {isLoading ? (
        <Loader onLoadingComplete={handleLoadingComplete} />
      ) : (
        <div className="overflow-hidden bg-bgcolor">
          <MicroAnimations />
          <CursorEffect />
          <Header />
          <Navbar />
          <Main />
          <Services />
          <About />
          <Project />
          <Contact />
        </div>
      )}
    </>
  );
}

export default App;
